import React from 'react'
import Shipping from '../features/checkout/Components/Shipping';

const CheckoutShippingPage = () => {
    document.title = "Shipping Information";
    return (
        <Shipping />
    )
}

export default CheckoutShippingPage